'use client';

import { FC, ReactNode, useEffect, useState } from 'react';

import { CartInitializer } from '@telialt/core-eshop/src/CartInitializer';
import { ClientSideError } from '@telialt/core-eshop/src/components/ClientSideError/ClientSideError';
import { AxiosCartError, CartError } from '@telialt/models/src/EshopModel';
import { DDComponent } from '@telialt/utils/src/datadog/setup';

import { useBaseProductFromUrlParam } from '../../../hooks/useBaseProductFromUrlParam';
import { ProductDetailsSkeleton } from '../ProductDetailsSkeleton/ProductDetailsSkeleton';

type Props = {
    children: ReactNode;
};

const ErrorComponent: FC<{ error?: AxiosCartError | CartError | Error }> = ({ error }) => (
    <ClientSideError error={error} component={DDComponent.EshopProduct} />
);

// ToDo: possible to combine (TranslationsInit, CartInitClientSide, UserDataInit) to single ProductPageInitializer
export const CartInitClientSide: FC<Props> = ({ children }) => {
    const { baseProduct } = useBaseProductFromUrlParam();

    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isMounted || !baseProduct) {
        return <ProductDetailsSkeleton />;
    }

    return (
        <CartInitializer.StrategyCreate
            baseProductCode={baseProduct.code}
            loadingPlaceholder={<ProductDetailsSkeleton />}
            ErrorComponent={ErrorComponent}
        >
            {children}
        </CartInitializer.StrategyCreate>
    );
};
